<template>
    <h1>ホームへ戻ってください</h1>
</template>
<style scoped>
    h1 {
        text-align: center;
        margin-top: 100px;
    }
</style>